// extracted by mini-css-extract-plugin
export default {"animationEnterMs":"700","animationExitMs":"1300"};